import { render, staticRenderFns } from "./AdminSectionHeader.vue?vue&type=template&id=8cc2bbbc&scoped=true&"
import script from "./AdminSectionHeader.vue?vue&type=script&lang=js&"
export * from "./AdminSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdminSectionHeader.vue?vue&type=style&index=0&id=8cc2bbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc2bbbc",
  null
  
)

export default component.exports